export default "__VITE_ASSET__0Lpl_B2Y__"